import { useParams } from 'react-router-dom';

import { useGetTelehealthSessionInfo } from '../../../hooks';
import { ProviderAvatar } from './ProviderAvatar';

export function ProviderAvatarWrapper() {
  const { providerShortId, patientShortId } = useParams();
  const { data, loading } = useGetTelehealthSessionInfo(providerShortId, patientShortId);
  const provider = data?.telehealthSessionInfo?.provider;
  const appointmentStartTime = data?.telehealthSessionInfo?.appointment?.timeStart;
  const appointmentEndTime = data?.telehealthSessionInfo?.appointment?.timeEnd;
  return (
    <ProviderAvatar
      appointmentStartTime={appointmentStartTime}
      appointmentEndTime={appointmentEndTime}
      provider={provider}
      loading={loading}
    />
  );
}
